import React, {useState} from "react";
import { useStripe, useElements, CardElement, CardNumberElement } from "@stripe/react-stripe-js";
import { Row, Col, Button } from "antd";
import CardSection from "./CardSection";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();
  const [saving, setSaving] = useState<boolean>(false);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setSaving(true);

    const card = elements.getElement(CardNumberElement);
    const result = await stripe.createToken(card);

    if (result.error) {
      // Show error to your customer.
      console.log(result.error.message);
    } else {
      // Send the token to your server.
      // This function does not exist yet; we will define it in the next step.
      //   stripeTokenHandler(result.token);
      console.log("token", result.token);

      setTimeout(()=>{
        setSaving(false);
      }, 3000)
    }
  };

  return (
    <div className="main-content">
      <form onSubmit={handleSubmit}>
        <Row>
          <CardSection />
        </Row>
        <Row className="action-grp mt-3">
          <Button htmlType="submit" loading={saving} className="beam-btn green-btn cover w-full"
             disabled={!stripe}>Confirm pay</Button>
        </Row>
      </form>
    </div>
  );
}
